import { render, staticRenderFns } from "./ProductsSection.vue?vue&type=template&id=04af8fdc&scoped=true&"
import script from "./ProductsSection.vue?vue&type=script&lang=js&"
export * from "./ProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSection.vue?vue&type=style&index=0&id=04af8fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af8fdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
